import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import {useQuery} from '@apollo/client';
import {Button, Skeleton} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {PAYMENT} from '../../../config/routes';
import {Store} from '../../../model/store/Store';
import {onlyCashOffers, onlyCashOffersVariables} from '../../../shared/graphql/__generated__/onlyCashOffers';
import {QUERY_SHOWCASE} from '../../../shared/graphql/showcase';
import {imgUrl} from '../../../shared/helpers/imgUrl';

import {Card} from './Card';

import cls from './Cards.module.scss'

export interface IOffer {
    name: string
    logo: string
    percent: string
    date: string
    value: string
    age: string
    URL: string
}

export const Cards = observer(() => {

    const {auth} = useInstance(Store)
    const navigate = useNavigate()

    const query = useQuery<onlyCashOffers,onlyCashOffersVariables>(QUERY_SHOWCASE, {
        variables: {
            token: auth.token!,
        }
    })

    if (query.loading) return <Skeleton active/>

    const items:IOffer[] = _.map(query.data?.onlyCashOffers, offer => (
        {
            name: offer.id!,
            logo: imgUrl(offer.attributes?.logo.data?.attributes?.url!),
            percent: offer.attributes?.percent!,
            date: offer.attributes?.term!,
            value: offer.attributes?.headline!,
            age: offer.attributes?.age!,
            URL: offer.attributes?.URL!,
        }
    ))

    return (
        <div>
            {!auth.paid &&
            <div className={cls.banner}>
                <h2>
                    Продолжайте заполнение анкеты и добавьте свою банковскую карту.
                </h2>
                <Button size={'large'} type={'primary'} icon={<RightOutlined/>} onClick={() => navigate(PAYMENT)}>Продолжить</Button>
            </div>
            }
        <div className={cls.cards}>
            {_.map(items, (item) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Card key={item.name} {...item}/>
            ))}
        </div>
        </div>
    )
})